import { Price } from '../../../types/interfaces';

export function findPriceForQuantity(prices: Price[], quantity: number): number {
  const match = prices.find(
    (p) =>
      quantity >= p.price_type.range_start &&
      quantity <= p.price_type.range_end
  );

  if (match && match.price > 0) {
    return match.price;
  }

  // Fallback: return maximum non-zero price (conservative approach)
  // Previously returned minimum, which could give undeserved discounts
  const nonZero = prices.filter((p) => p.price > 0);
  if (nonZero.length === 0) return 0;

  return nonZero.reduce((max, p) => (p.price > max ? p.price : max), nonZero[0].price);
}
